import styled from 'styled-components';

export const StyledForm = styled.form`
  padding: 15px;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 15px;
  background-color: #fff;
  border: 1px solid #E5E5E5;
  border-radius: 5px;
  box-shadow: 0 2px 4px #C4C4C4;
  position: relative;
`;

export const StyledFormContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 15px;
`;

export const StyledFormAction = styled.div`
  display: inline-grid;
  justify-content: end;
  grid-gap: 15px;
`;